import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home'

const project = require('../../project')

const md5 = require('md5')
// console.log(path.resolve(__dirname, '../'))
// console.log(path.resolve(__dirname, '../../../nnd'))

const env = process.env.NODE_ENV

// const path = require('path')

const folderMD5 = md5(project.name)

Vue.use(Router)

const router = new Router({
  // base: path.resolve(__dirname,`/dnaeditorial/DNAProject/dist/${env}/${folderMD5}/`),
  // base: ((env !== 'production') ? `/dnaeditorial/DNAProject/dist` : '/'),
  base: (env === 'testing') ? '/' : (project.assetPath[env] + folderMD5),
  mode: 'abstract',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      props: true
    }
  ]
})

// router.beforeEach((to, from, next) => {
//   if (to.name !== 'expert') {
//     router.push({
//       name: 'expert'
//     })
//   } else {
//     next()
//   }
// })

router.replace('/')

export default router



// WEBPACK FOOTER //
// ./src/router/index.js